import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { styled } from '@mui/material/styles';
import React from 'react';

const PREFIX = 'OperatorSelect';

const classes = {
  bgHover: `${PREFIX}-bgHover`
};

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  [`& .${classes.bgHover}`]: {
    '&:hover': {
      background: theme.palette.primary.light
    }
  }
}));

const OperatorSelect = ({ items, setField, selectedKey }: any) => {
  const onChangeHandler = (e: any) => {
    setField(e.target.value);
  };

  return (
    <StyledFormControl variant="outlined" fullWidth>
      <Select
        className={classes.bgHover}
        value={selectedKey || ''}
        displayEmpty
        onChange={onChangeHandler}
        inputProps={{
          name: 'operator',
          id: 'operator-select'
        }}
      >
        {items.map((item: any) => (
          <MenuItem key={item.key} value={item.key}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </StyledFormControl>
  );
};

export default OperatorSelect;
